
export default {
    name: 'ListPagination',
    props: {
        pageLength: {
            type: Number,
        },
        isLast: {
            type: Boolean,
            default: false,
        },
        syncPage: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            firstPage: 1,
            endPage: 5,
            nextCount: 1, // > 를 누른 횟수
            clickedIndex: 0,
        }
    },
    computed: {
        pageNumber() {
            const pageNumber = Math.ceil(this.pageLength / 5)

            return pageNumber
        },
    },
    updated() {
        this.clickedIndex = this.syncPage
    },
    methods: {
        onClickNext() {
            this.nextCount++
            this.clickedIndex = 0
            this.$emit('getPosition', this.nextCount)
        },
        onClickPrev() {
            this.nextCount--
            this.clickedIndex = 0
            this.$emit('getPosition', this.nextCount)
        },
        onClickPage(idx) {
            this.clickedIndex = idx
            this.$emit('curIdx', idx)
        },
    },
}
